import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// code imports
import React, { Suspense, useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from './components/Pages/Home/Home';
import faqConfig from './components/Pages/AdminPanel/Tabs/FAQs/faq_config.json';

// static imports (no React.lazy)
const AdminPanel = React.lazy(() => import('./components/Pages/AdminPanel/AdminPanel'));

/*
const SignUp = React.lazy(() => import('./components/Pages/SignUp/SignUp'));
const LogIn = React.lazy(() => import('./components/Pages/LogIn/LogIn'));
const Dashboard = React.lazy(() => import("./components/Pages/Dashboard/Dashboard"));
const LinkWallet = React.lazy(() => import('./components/Pages/LinkWallet/LinkWallet'));
const Marketplace = React.lazy(() => import('./components/Pages/Marketplace/Marketplace'));
const ItemView = React.lazy(() => import('./components/Pages/ItemView/ItemView'));
const ModelView = React.lazy(() => import('./components/Pages/ModelView/ModelView'));
const Wallet = React.lazy(() => import('./components/Pages/Wallet/Wallet'));
const Profile = React.lazy(() => import('./components/Pages/Profile/Profile'));
const PlayerCards = React.lazy(() => import('./components/Pages/PlayerCards/PlayerCards'));
*/
const About = React.lazy(() => import('./components/Pages/About/About'));
const CorporateTournament = React.lazy(() => import('./components/Pages/CorporateTournament/DallasCenterTournament'));
// const Career = React.lazy(() => import('./components/Pages/Career/Career')); not used
const Terms = React.lazy(() => import('./components/Pages/Terms/Terms'));
const PrivacyPolicy = React.lazy(() => import('./components/Pages/PrivacyPolicy/PrivacyPolicy'));
const CommunityGuidelines = React.lazy(() => import('./components/Pages/CommunityGuidelines/CommunityGuidelines'));
const RefundPolicy = React.lazy(() => import('./components/Pages/RefundPolicy/RefundPolicy'));
const FAQ = React.lazy(() => import('./components/Pages/FAQ/FAQ'));
const HitStatsLogin = React.lazy(() => import('./components/Pages/GameInfo/YourSquad/HitStats'));
const YourSquad = React.lazy(() => import('./components/Pages/GameInfo/YourSquad/TeamStats'));
const HitStatsPlayerPage = React.lazy(() => import('./components/Pages/GameInfo/YourSquad/PlayerPage'));
// Homepage - React version (Phase 2)
const HitstatsLandingPage = React.lazy(() => import('./components/Pages/GameInfo/YourSquad/HomePage/HomePage'));
const TennisProto = React.lazy(() => import('./components/Pages/GameSimsProto/tennis'));
const VipLB = React.lazy(() => import('./components/Pages/vip-leaderboard'));
const BaseballProto = React.lazy(() => import('./components/Pages/GameSimsProto/baseball'));
const CreatorProgram = React.lazy(() => import('./components/Pages/Growth/creator-program'));
const CreatorProgram2 = React.lazy(() => import('./components/Pages/Growth/creator-program-2'));
const Rewards = React.lazy(() => import('./components/Pages/Rewards/Rewards'));


/* HCL - START */
const HCL_HOME = React.lazy(() => import('./components/Pages/LiveOps/HCL/Home/Home'));
const HCL_CITIES = React.lazy(() => import('./components/Pages/LiveOps/HCL/Cities/Cities'));
const HCL_SCHEDULE = React.lazy(() => import('./components/Pages/LiveOps/HCL/Schedule/Schedule'));
const HCL_TEAM = React.lazy(() => import('./components/Pages/LiveOps/HCL/Team/Team'));
const HCL_GUIDELINES = React.lazy(() => import('./components/Pages/LiveOps/HCL/Guidelines/Guidelines'));
/* HCL - END */


/* YC - START */
const YCHome = React.lazy(() => import('./components/Pages/LiveOps/YC/Home/Home'));
const YCSchedule = React.lazy(() => import('./components/Pages/LiveOps/YC/Schedule/Schedule'));
const YCGuidelines = React.lazy(() => import('./components/Pages/LiveOps/YC/Guidelines/Guidelines'));
const YCTopPlayers = React.lazy(() => import('./components/Pages/LiveOps/YC/TopPlayers/TopPlayers'));
/* YC - END */

/* EYC - START */
const EYCHome = React.lazy(() => import('./components/Pages/LiveOps/EYC/Home/Home'));
const EYCSchedule = React.lazy(() => import('./components/Pages/LiveOps/EYC/Schedule/Schedule'));
const EYCGuidelines = React.lazy(() => import('./components/Pages/LiveOps/EYC/Guidelines/Guidelines'));
const EYCTopPlayers = React.lazy(() => import('./components/Pages/LiveOps/EYC/TopPlayers/EYCTopPlayers'));
/* EYC - END */

/* ABR - START */
const ABRHome = React.lazy(() => import('./components/Pages/LiveOps/ABR/App'));
/* ABR - END */

const AccountFAQPage = React.lazy(() => import('./components/Pages/FAQ_Pages/AccountFAQ_Page'));

const ModelView = React.lazy(() => import('./components/Pages/ModelView/ModelView'));

const IGDC = React.lazy(() => import('./components/Pages/IGDC/IGDC'));
const HPLPage = React.lazy(() => import('./components/Pages/HPL/HPLPage'));
const HitwicketWrapped = React.lazy(() => import('./components/Pages/Hw-wrap/App'));


const faqRoutes = faqConfig.faq_types.map(({ name, path, title }) => ({
  path,
  component: AccountFAQPage,
  faq_type: name,
  title,
}));

const ProtectedRoute = ({ children }) => {
  const user = localStorage.getItem("hw_user");
  if (!user) {
    return <Navigate to="/hitstats/login" replace />;
  }
  return children;
};


function Loader() {

  // lottie + animation JSON are only needed while a lazy route loads, so keep them out of the main bundle
  useEffect(() => {
    let anim;
    let cancelled = false;
    Promise.all([
      import("lottie-web/build/player/lottie_light"),
      import("./assets/common/cricket-bat-ball-anim.json"),
    ]).then(([lottieModule, animModule]) => {
      const container = document.getElementById("loading_screen");
      if (cancelled || !container) return;
      anim = (lottieModule.default || lottieModule).loadAnimation({
        container,
        animationData: animModule.default || animModule,
        renderer: "svg",
        loop: true,
        autoplay: true,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid"
        }
      });
    });
    return () => {
      cancelled = true;
      if (anim) anim.destroy();
    };
  }, []);

  return (
    <div className='row'>
      <div className='col-12 p-0'>
        <div className='w-100 h-100 d-flex justify-content-center align-items-center'
          style={{ minHeight: '100vh', backgroundColor: 'rgb(25, 6, 46)' }}>
          <section id="loading_screen" style={{ maxWidth: '128px', maxHeight: '128px' }} />
        </div>
      </div>
    </div>
  );
}


function App() {

  const Redirect = props => {
    useEffect(() => {
      window.location.replace(props.href)
    }, [])
    return null;
  }

  return (
    <div className="App" style={{ fontFamily: 'Montserrat', overflow: "hidden" }}>
      <BrowserRouter>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/" element={<Home />} />
            <Route path="/career" element={
              <Redirect href="https://pear-teal-79a.notion.site/Work-at-Hitwicket-105e348bbbca80c7ad3be17555990d09?pvs=73" />
            } />
            <Route path="/about" element={<About />} />
            <Route path="/tennis-prototype" element={<TennisProto />} />
            <Route path="/vip-leaderboard" element={<VipLB />} />
            <Route path="/baseball-prototype" element={<BaseballProto />} />
            <Route path="/creator-program" element={<CreatorProgram />} />
            <Route path="/creator-program/top-creators" element={<CreatorProgram2 />} />
            <Route path="/corporate-tournament" element={<CorporateTournament />} />
            <Route path="/dallascentertournament" element={<Navigate to="/corporate-tournament" replace />} />
            <Route path="/HPL" element={<HPLPage />} />
            <Route path="/HPL/" element={<HPLPage />} />
            <Route path="/HPL/*" element={<HPLPage />} />
            <Route path="/hw-wrap" element={<HitwicketWrapped />} />
            <Route path="/nominations" element={<HPLPage />} />
            <Route path="/hitstats" element={<Navigate to="/hitstats/login" replace />} />
            <Route path="/hitstats/login" element={<HitStatsLogin />} />
            <Route path="/hitstats/team" element={<YourSquad />} />
            <Route path="/hitstats/player/:id" element={<HitStatsPlayerPage />} />
            <Route path="/hitstats/home" element={<HitstatsLandingPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/community-guidelines" element={<CommunityGuidelines />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/faq" exact element={<FAQ />} />
            <Route path="/pavilion" element={
              <Redirect href={`https://pavilion.hitwicket.com${window.location.search}`} />
            } />
            {/*
              <Route path="/signup" element={<SignUp />} />
              <Route path="/login" element={<LogIn />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/link-wallet" element={<LinkWallet />} />
              <Route path="/modelview" element={<ModelView />} />
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/itemview" element={<ItemView />} />
              <Route path="/wallet" element={<Wallet />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/player-card" element={<PlayerCards />} />
            */}
            <Route path="/modelview" element={<ModelView />} />

            {/* HCL - START */}
            <Route path="/hcl" element={<HCL_HOME />} />
            <Route path="/hcl-cities" element={<HCL_CITIES />} />
            <Route path="/hcl-schedule" element={<HCL_SCHEDULE />} />
            <Route path="/hcl-team" element={<HCL_TEAM />} />
            <Route path="/hcl-guidelines" element={<HCL_GUIDELINES />} />
            {/* HCL - END */}

            <Route path='/igdc' element={<IGDC />} />

            {/* YC - START */}
            <Route path="/yc" element={<YCHome />} />
            <Route path="/yc-schedule" element={<YCSchedule />} />
            <Route path="/yc-top-players" element={<YCTopPlayers />} />
            <Route path="/yc-guidelines" element={<YCGuidelines />} />
            {/* YC - END */}

            {/* EYC - START */}
            <Route path="/eyc" element={<EYCHome />} />
            <Route path="/eyc-schedule" element={<EYCSchedule />} />
            <Route path="/eyc-top-players" element={<EYCTopPlayers />} />
            <Route path="/eyc-guidelines" element={<EYCGuidelines />} />
            {/* EYC - END */}

            {/* ABR - START */}
            <Route path="/alliance-battle-royale" element={<ABRHome />} />

            {/* ABR - END */}

            {/* Rewards */}
            <Route path="/rewards" element={<Rewards />} />

            {/* FAQ Pages - START */}
            {
              faqRoutes.map(({ path, component: Component, faq_type, title }) => (
                <Route key={path} path={path} element={
                  <Component
                    faq_type={faq_type}
                    title={title}
                  />
                }
                />
              ))}
            {/* FAQ Pages - END */}
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;

